import icon1 from "../images/icon/research.gif";
import icon2 from "../images/icon/durability.gif";
import icon3 from "../images/icon/digital-tra.gif";
import icon4 from "../images/icon/business-develop.gif";
import icon5 from "../images/icon/search.gif";
import icon6 from "../images/icon/warning.gif";
// import icon6 from "../images/icon/phone.gif";

import sicon1 from "../images/icon/ser-icon01.svg";
import sicon2 from "../images/icon/ser-icon02.svg";
import sicon3 from "../images/icon/ser-icon03.svg";
import webico from "../images/icon/ser-icon04.svg";
import crmico from "../images/icon/newcrm.svg";
import whatsappico from "../images/icon/whatsappico.svg";
import webchatico from "../images/icon/webchatico.svg";
import buisnessico from "../images/icon/businessico.svg";
import graphicdesignico from "../images/icon/graphicdesignico.svg";
import securityico from "../images/icon/securityico.svg";
import socialmediaico from "../images/icon/socialmediaico.svg";

import web from "../images/service/core1.jpg";
import crm from "../images/service/Core_Practice.png";
import whatsapp from "../images/service/core1.jpg";
import webchat from "../images/service/Core_Practice.png";
import buisness from "../images/service/core1.jpg";
import graphicdesign from "../images/service/core1.jpg";
import security from "../images/service/Core_Practice.png";
import socialmedia from "../images/service/Core_Practice.png";

import sdicon1 from "../images/icon/da-fea_icon01.svg";
import sdicon2 from "../images/icon/da-fea_icon02.svg";
import sdicon3 from "../images/icon/da-fea_icon03.svg";
import sdicon4 from "../images/icon/da-fea_icon04.svg";

import scicon1 from "../images/icon/airdrop-white.svg";
import scicon2 from "../images/icon/cloud-add.svg";
import scicon3 from "../images/icon/check02.svg";
import scicon4 from "../images/icon/finger-scan.svg";
import scicon5 from "../images/icon/ranking.svg";

import cdicon1 from "../images/icon/cd-ser_icon01.svg";
import cdicon2 from "../images/icon/cd-ser_icon02.svg";
import cdicon3 from "../images/icon/cd-ser_icon03.svg";
import cdicon4 from "../images/icon/cd-ser_icon04.svg";
import cdicon5 from "../images/icon/cd-ser_icon05.svg";
import cdicon6 from "../images/icon/cd-ser_icon06.svg";
import cdicon7 from "../images/icon/cd-ser_icon08.svg";
import cdicon8 from "../images/icon/cd-ser_icon09.svg";

import sImg1 from "../images/icon/sd-icon01.svg";
import sImg2 from "../images/icon/sd-icon02.svg";
import sImg3 from "../images/icon/sd-icon03.svg";
import sImg4 from "../images/icon/sd-icon04.svg";

import weblogo from "../images/hero/cd-img.png";
import salesnestCrm from "../images/service/Salesnest_Logo_PNG.png";
import whatsapplogo from "../images/hero/cd-img.png";
import webchatlogo from "../images/hero/cd-img.png";
import buisnesslogo from "../images/hero/cd-img.png";
import securitylogo from "../images/hero/cd-img.png";
import graphicdesignlogo from "../images/hero/cd-img.png";
import socialmedialogo from "../images/hero/cd-img.png";

const Services = [
  {
    Id: "1",
    sImg: icon1,
    title: "Web & App Development",
    logoService: weblogo,
    slug: "web-mobile",
    officialSite: "",
    shortDescription: "Crafting Digital Interfaces That Convert",
    info: "We build responsive, SEO-friendly websites and mobile apps tailored to your business objectives. From startups to enterprises, we ensure your online presence is both visually impressive and technically flawless.",
    description:
      "We craft responsive, SEO-optimized websites and mobile apps that align with your business goals and deliver performance.",
    whyUs: [
      "Static, Dynamic, and CMS-Based Websites (WordPress, Custom PHP)",
      "E-Commerce Portals (WooCommerce, Shopify, Custom Builds)",
      "Hybrid & Native Mobile Apps (Flutter, React Native, Android/iOS)",
      "Progressive Web Applications (PWAs)",
      "Custom Web Application UI/UX Design",
      "Lightning-fast load speeds & optimized code",
      "Mobile-first, responsive layouts",
      "Seamless user journey & high conversion rate design",
      "Admin panels for easy content updates",
    ],
    serviceProcess: [
      {
        title: "Requirement Gathering",
        desc: "Understand your business, users, and goals.",
        icon: sImg1,
      },
      {
        title: "Wireframing & Design",
        desc: "Create a visual plan and design system.",
        icon: sImg2,
      },
      {
        title: "Agile Development",
        desc: "Break into sprints and build iteratively.",
        icon: sImg3,
      },
      {
        title: "Testing & QA",
        desc: "Ensure a bug-free, responsive experience.",
        icon: sImg4,
      },
    ],
    serviceOutcome: [
      "Faster page loads and improved SEO",
      "Streamlined user flows and UX",
      "Cross-device compatibility",
      "High conversion rates",
      "Seamless backend management",
      "Brand-consistent UI",
    ],
    needDemo: `📞 Need a demo or consultation?
    Email: hello@anantkamalstudios.com
    Phone: +91 76202 37235
🌐  www.anantkamalstudios.com`,
  },
  {
    Id: "2",
    sImg: icon2,
    title: "Custom CRM Solutions",
    logoService: salesnestCrm,
    slug: "custom-crm",
    officialSite: "www.salesnest.in",
    shortDescription: "Custom CRM Software to Organize, Automate & Grow",
    info: "Every business is unique—so should be your CRM. We build tailor-made CRM systems that empower your teams to track leads, manage client relationships, and automate workflows efficiently.",
    description:
      "Our CRM software is customized to your business needs, helping you improve client management, task automation, and data-driven decisions.",
    whyUs: [
      "Lead Management & Sales Pipeline",
      "Custom Roles & Permissions",
      "Automated Follow-ups & Reminders",
      "Task and Project Management Modules",
      "Email & SMS Integration",
      "Customer Support Ticketing",
      "Advanced Reporting & Analytics",
      "Multi-platform Access (Web & Mobile)",
    ],
    serviceProcess: [
      {
        title: "Workflow Analysis",
        icon: sImg1,
        desc: "We understand your business logic and operations.",
      },
      {
        title: "System Architecture",
        icon: sImg2,
        desc: "Design the modules, data flow, and automation logic.",
      },
      {
        title: "CRM Development",
        icon: sImg3,
        desc: "Build your CRM system tailored to your operations.",
      },
      {
        title: "Training & Launch",
        icon: sImg4,
        desc: "We onboard your team and provide documentation.",
      },
    ],
    serviceOutcome: [
      "Centralized lead and client data",
      "Faster follow-ups and reduced delays",
      "Improved team collaboration",
      "Higher conversion rates",
      "Actionable analytics and reports",
    ],
    needDemo: `📞 Need a CRM Demo?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  {
    Id: "3",
    sImg: icon3,
    logoService: whatsapplogo,
    title: "WhatsApp Business API",
    slug: "whatsapp-api",
    officialSite: "anantkamalwademo.online/",
    shortDescription: "Connect, Automate & Grow with Official WhatsApp API",
    info: "Anantkamal Studios is an official Meta Tech Solution Provider. We offer end-to-end integration of WhatsApp Business APIs to streamline customer support, sales, and marketing.",
    description:
      "Leverage the power of WhatsApp to automate customer support, send alerts, and drive real-time engagement through verified business communication.",
    whyUs: [
      "Official Meta Tech Partner Integration",
      "Broadcast & Template Messaging",
      "Multi-Agent Support Dashboard",
      "E-commerce Integration (Cart, Orders)",
      "Automation via Webhooks & CRM",
      "Analytics and Conversion Tracking",
      "Secure & Compliant Communication",
    ],
    serviceProcess: [
      {
        title: "Business Verification",
        icon: sImg1,
        desc: "We help you get verified by Meta.",
      },
      {
        title: "API Setup & Integration",
        icon: sImg2,
        desc: "Configure WhatsApp API into your CRM, website or app.",
      },
      {
        title: "Automation & Flows",
        icon: sImg3,
        desc: "We set up auto-replies, templates & workflows.",
      },
      {
        title: "Launch & Monitoring",
        icon: sImg4,
        desc: "Track message delivery, engagement & feedback.",
      },
    ],
    serviceOutcome: [
      "Faster customer response",
      "Automated lead capture",
      "Higher open rates than email",
      "Verified brand identity",
      "Boost in customer trust",
    ],
    needDemo: `📞 Want to Automate via WhatsApp?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  {
    Id: "4",
    sImg: icon4,
    logoService: webchatlogo,
    title: "Live Chat Integration",
    slug: "live-chat",
    officialSite: "",
    shortDescription: "Real-Time Conversations. Real-Time Conversions.",
    info: "We implement intelligent live chat tools into your website to boost engagement and capture leads instantly.",
    description:
      "Live chat tools improve customer engagement, reduce bounce rates, and help convert visitors to leads by offering instant communication channels.",
    whyUs: [
      "Live Chat Tool Integration (Tawk.to, Crisp, Intercom)",
      "WhatsApp & Messenger Widgets",
      "AI Chatbot Setup",
      "Custom Chatbot Flows",
      "Lead Form Integration with CRM",
      "Multi-Agent Support",
      "Real-Time Notifications",
    ],
    serviceProcess: [
      {
        title: "Tool Selection",
        icon: sImg1,
        desc: "Choose the right chat tool for your business.",
      },
      {
        title: "Integration",
        icon: sImg2,
        desc: "Embed live chat or chatbot into your website/app.",
      },
      {
        title: "Workflow Setup",
        icon: sImg3,
        desc: "Set up auto-replies, form captures & triggers.",
      },
      {
        title: "Monitoring & Optimization",
        icon: sImg4,
        desc: "Track performance and adjust flows as needed.",
      },
    ],
    serviceOutcome: [
      "Higher visitor engagement",
      "Instant customer assistance",
      "Increased conversions",
      "24/7 automated support",
      "Lead data capture",
    ],
    needDemo: `💬 Start chatting with your leads instantly!
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  {
    Id: "5",
    sImg: icon5,
    logoService: buisnesslogo,
    title: "Digital Business Cards",
    slug: "digital-cards",
    officialSite: "www.bizcardspro.in ",
    shortDescription: "Smart Networking. Paperless. Shareable. Interactive.",
    info: "Go beyond traditional paper cards. We provide innovative digital business card systems that are QR-enabled, web-based, and instantly shareable.",
    description:
      "Ditch paper cards. Our digital cards are sleek, shareable, and customizable—perfect for modern professionals and teams.",
    whyUs: [
      "QR Enabled Card Designs",
      "Mobile Responsive & Web Based",
      "Contact Save, Social Media, Email, Location",
      "Custom Domains & Branding",
      "Team Dashboard for Bulk Cards",
      "Interactive Call-to-Actions",
      "Analytics & Visit Tracking",
    ],
    serviceProcess: [
      {
        title: "Design Selection",
        icon: sImg1,
        desc: "Pick from our templates or go fully custom.",
      },
      {
        title: "Profile Setup",
        icon: sImg2,
        desc: "Add your contact info, socials & CTAs.",
      },
      {
        title: "Deployment",
        icon: sImg3,
        desc: "Host on your domain or ours.",
      },
      {
        title: "Distribution",
        icon: sImg4,
        desc: "Share via QR, link, NFC or signature.",
      },
    ],
    serviceOutcome: [
      "No printing costs",
      "Easy to update",
      "Professional first impression",
      "Trackable engagement",
      "Eco-friendly",
    ],
    needDemo: `📇 Need a Digital Business Card?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  {
    Id: "6",
    sImg: icon6,
    logoService: salesnestCrm,
    title: "Creative Design Services",
    slug: "design-services",
    shortDescription: "Design That Reflects Identity, Builds Authority",
    info: "We transform ideas into compelling visuals that communicate your brand’s essence, whether you need a logo, pitch deck, brochure, or packaging design.",
    description:
      "From branding to marketing collateral, we design with purpose—to enhance recognition, trust, and impact.",
    whyUs: [
      "Logo & Brand Identity",
      "Pitch Decks & Presentations",
      "Brochures, Flyers, and Posters",
      "Packaging & Label Design",
      "Business Cards & Stationery",
      "Social Media Post Design",
      "UI/UX Design for Web & Apps",
    ],
    serviceProcess: [
      {
        title: "Briefing & Research",
        icon: sImg1,
        desc: "Understand your brand and audience.",
      },
      {
        title: "Concept Creation",
        icon: sImg2,
        desc: "Develop multiple visual directions.",
      },
      {
        title: "Design Finalization",
        icon: sImg3,
        desc: "Refine and finalize the best concept.",
      },
      {
        title: "Delivery & Support",
        icon: sImg4,
        desc: "Provide assets and ongoing creative help.",
      },
    ],
    serviceOutcome: [
      "Unique brand identity",
      "Increased brand recall",
      "Professional presentations",
      "Sales-driven marketing assets",
      "Social media presence boost",
    ],
    needDemo: `🎨 Need custom design?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  //   Core Section
  {
    Id: "7",
    sImg: web,
    sIcon: webico,
    logoService: weblogo,
    title: "Website & Mobile App Design & Development",
    slug: "IT-management",
    shortDescription: "Modern, Responsive, and Scalable Digital Experiences",
    info: "We design and build responsive websites and mobile applications that deliver exceptional user experiences and align with your business goals.",
    description:
      "From wireframes to launch, we combine creative UI/UX design with robust development practices to create digital platforms that are intuitive, scalable, and performance-optimized.",
    whyUs: [
      "Custom Web Development",
      "Cross-Platform Mobile Apps",
      "Responsive UI/UX Design",
      "E-commerce & CMS Platforms",
      "Progressive Web Apps",
      "SEO & Speed Optimization",
      "Ongoing Maintenance & Support",
    ],
    serviceProcess: [
      {
        title: "Requirement Gathering",
        icon: sImg1,
        desc: "Understand your goals, users, and technical needs.",
      },
      {
        title: "Wireframing & UI Design",
        icon: sImg2,
        desc: "Create intuitive and user-friendly interfaces.",
      },
      {
        title: "Development & Integration",
        icon: sImg3,
        desc: "Build scalable and responsive solutions.",
      },
      {
        title: "Testing & Deployment",
        icon: sImg4,
        desc: "Ensure quality, performance, and launch readiness.",
      },
    ],
    serviceOutcome: [
      "User-centric interfaces",
      "Faster time-to-market",
      "Cross-device compatibility",
      "Improved user engagement",
      "Business process automation",
    ],
    needDemo: `🌐 Want to digitize your business?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  {
    Id: "8",
    sImg: crm,
    sIcon: crmico,
    logoService: salesnestCrm,
    title: "CRM Systems",
    slug: "crm-systems",
    shortDescription: "Centralize Your Customer Data & Drive Engagement",
    info: "We build and customize CRM platforms that help manage leads, automate sales, and improve customer relationships.",
    description:
      "Our CRM systems are tailored to meet your business workflows, offering automation, analytics, and seamless integration to optimize your sales and support functions.",
    whyUs: [
      "Custom CRM Development",
      "Lead & Pipeline Management",
      "Automation & Task Scheduling",
      "Analytics & Reports",
      "Third-Party Integrations",
      "Role-based Access Control",
      "Data Security & Backups",
    ],
    serviceProcess: [
      {
        title: "Needs Analysis",
        icon: sImg1,
        desc: "Identify CRM goals and user workflows.",
      },
      {
        title: "System Architecture",
        icon: sImg2,
        desc: "Plan modules and integrations.",
      },
      {
        title: "Development & Testing",
        icon: sImg3,
        desc: "Build and test the CRM environment.",
      },
      {
        title: "Training & Support",
        icon: sImg4,
        desc: "Ensure smooth adoption and provide documentation.",
      },
    ],
    serviceOutcome: [
      "Centralized customer database",
      "Streamlined sales process",
      "Improved team collaboration",
      "Actionable customer insights",
      "Increased productivity",
    ],
    needDemo: `📊 Need a custom CRM?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  {
    Id: "9",
    sImg: whatsapp,
    sIcon: whatsappico,
    logoService: whatsapplogo,
    title: "WhatsApp Business",
    slug: "whats-app-buisness-api",
    shortDescription: "Automate Conversations with the Most Used Messaging App",
    info: "Enable direct communication with customers using WhatsApp API to send alerts, respond automatically, and enhance engagement.",
    description:
      "We help businesses integrate WhatsApp Business API for customer support, marketing automation, and real-time notifications—fully compliant and scalable.",
    whyUs: [
      "Official WhatsApp API Setup",
      "Chatbot Integration",
      "CRM Integration",
      "Transactional Notifications",
      "Lead Capture Automation",
      "Multi-agent Support",
      "Analytics & Reporting",
    ],
    serviceProcess: [
      {
        title: "API Approval & Setup",
        icon: sImg1,
        desc: "Get verified and configure WhatsApp API.",
      },
      {
        title: "Bot Flow & Integration",
        icon: sImg2,
        desc: "Build flows and integrate with systems.",
      },
      {
        title: "Automation & Testing",
        icon: sImg3,
        desc: "Implement auto-responses and test flows.",
      },
      {
        title: "Launch & Monitor",
        icon: sImg4,
        desc: "Go live and track engagement performance.",
      },
    ],
    serviceOutcome: [
      "Automated customer support",
      "Real-time communication",
      "Reduced operational cost",
      "Higher engagement rates",
      "24/7 availability",
    ],
    needDemo: `💬 Want WhatsApp Automation?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  {
    Id: "10",
    sImg: webchat,
    sIcon: webchatico,
    logoService: webchatlogo,
    title: "Web Chat Solutions",
    slug: "webchat-solutions",
    shortDescription: "Convert Visitors into Leads with Real-Time Chat",
    info: "We integrate smart, automated web chat tools that provide 24/7 support, capture leads, and enhance customer experience directly from your website.",
    description:
      "Web chat solutions reduce bounce rates and drive instant communication. Our solutions include chatbot flows, live agent handover, lead routing, and analytics—all tailored to your business needs.",
    whyUs: [
      "AI-Powered Chatbots",
      "Live Chat Support Integration",
      "CRM & Email Integration",
      "Lead Qualification Automation",
      "Multi-language Support",
      "Mobile-Friendly UI",
      "User Behavior Tracking",
    ],
    serviceProcess: [
      {
        title: "Platform Selection",
        icon: sImg1,
        desc: "Choose the right chat platform (e.g., Tidio, Freshchat).",
      },
      {
        title: "Chatbot Flow Design",
        icon: sImg2,
        desc: "Map conversation flows and lead journeys.",
      },
      {
        title: "Integration & Setup",
        icon: sImg3,
        desc: "Connect chat with CRM and web systems.",
      },
      {
        title: "Testing & Optimization",
        icon: sImg4,
        desc: "Ensure performance, accuracy, and UX quality.",
      },
    ],
    serviceOutcome: [
      "Faster lead conversion",
      "24/7 website support",
      "Reduced drop-off rates",
      "Improved engagement",
      "Actionable chat analytics",
    ],
    needDemo: `💻 Want web chat integration?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  {
    Id: "11",
    sImg: buisness,
    sIcon: buisnessico,
    logoService: buisnesslogo,
    title: "Digital Business Cards",
    slug: "digital-business-cards",
    shortDescription: "Smart, Shareable, and Eco-Friendly Business Cards",
    info: "Ditch the paper and switch to interactive digital business cards—custom-designed and easily shareable via QR, link, or NFC.",
    description:
      "We craft personalized digital cards that showcase your brand, allow instant contact saving, and link directly to your social, website, or portfolios—all hosted online for convenience.",
    whyUs: [
      "Custom Branded Designs",
      "Contactless NFC Cards",
      "QR & Link Sharing Options",
      "Mobile-Optimized Interface",
      "Analytics on Views/Clicks",
      "Editable Anytime",
      "Hosting & Support Included",
    ],
    serviceProcess: [
      {
        title: "Design Consultation",
        icon: sImg1,
        desc: "Understand your brand and info needs.",
      },
      {
        title: "Digital Card Creation",
        icon: sImg2,
        desc: "Design a sleek, responsive digital card.",
      },
      {
        title: "Hosting & Setup",
        icon: sImg3,
        desc: "Publish your card with QR/NFC options.",
      },
      {
        title: "Ongoing Edits & Support",
        icon: sImg4,
        desc: "Update or maintain your card anytime.",
      },
    ],
    serviceOutcome: [
      "Professional first impression",
      "Increased contact sharing",
      "Eco-friendly branding tool",
      "Instant access across platforms",
      "Real-time info updates",
    ],
    needDemo: `📇 Want a smart business card?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  {
    Id: "12",
    sImg: security,
    sIcon: securityico,
    logoService: securitylogo,
    title: "Data Tracking",
    slug: "Data-tracking-&-security",
    shortDescription: "Secure Your Data, Monitor Your Metrics",
    info: "We help businesses implement systems that track digital activity securely while ensuring data protection, compliance, and risk mitigation.",
    description:
      "Our solutions provide insights into user behavior, app performance, and system security using analytics tools and security protocols that protect both data and reputation.",
    whyUs: [
      "Google Analytics & Tag Manager Setup",
      "Conversion & Funnel Tracking",
      "Real-time User Monitoring",
      "Data Encryption & Backups",
      "Firewall & Intrusion Detection",
      "GDPR & Compliance Support",
      "Security Audit & Testing",
    ],
    serviceProcess: [
      {
        title: "Assessment & Strategy",
        icon: sImg1,
        desc: "Analyze data flow and risks.",
      },
      {
        title: "Tracking Tool Integration",
        icon: sImg2,
        desc: "Install analytics, heatmaps, and monitoring tools.",
      },
      {
        title: "Security Protocol Setup",
        icon: sImg3,
        desc: "Implement firewalls, SSL, backups, and more.",
      },
      {
        title: "Testing & Compliance",
        icon: sImg4,
        desc: "Ensure secure and accurate tracking with full compliance.",
      },
    ],
    serviceOutcome: [
      "Real-time data visibility",
      "Improved marketing decisions",
      "Strong data protection",
      "Lower risk of breaches",
      "Compliance assurance",
    ],
    needDemo: `🔐 Need secure tracking systems?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  {
    Id: "13",
    sImg: graphicdesign,
    sIcon: graphicdesignico,
    logoService: graphicdesignlogo,
    title: "Graphic Design",
    slug: "graphic-design-branding",
    shortDescription: "Visual Branding That Makes You Unforgettable",
    info: "We create cohesive brand visuals that speak directly to your audience—logos, brand guides, product packaging, social templates, and more.",
    description:
      "Branding is more than design—it’s about how people feel about your business. We blend strategy and aesthetics to make sure your brand is instantly recognizable and emotionally resonant.",
    whyUs: [
      "Custom Logo Design",
      "Brand Style Guidelines",
      "Social Media Templates",
      "Product & Packaging Design",
      "Print Collateral (flyers, posters)",
      "UI Elements for Web & App",
      "Merch & Promo Material Design",
    ],
    serviceProcess: [
      {
        title: "Brand Discovery",
        icon: sImg1,
        desc: "Understand your brand vision, audience, and values.",
      },
      {
        title: "Concept Design",
        icon: sImg2,
        desc: "Create initial visual identity and assets.",
      },
      {
        title: "Refinement & Feedback",
        icon: sImg3,
        desc: "Collaborate with you for final perfection.",
      },
      {
        title: "Delivery & Guidelines",
        icon: sImg4,
        desc: "Deliver assets and brand use documentation.",
      },
    ],
    serviceOutcome: [
      "Stronger brand identity",
      "Higher visual consistency",
      "Better market recognition",
      "Improved customer trust",
      "Design assets ready to deploy",
    ],
    needDemo: `🎨 Ready to elevate your brand?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  {
    Id: "14",
    sImg: socialmedia,
    sIcon: socialmediaico,
    logoService: socialmedialogo,
    title: "Social Media Manage",
    slug: "social-media-management",
    shortDescription: "Grow Online with Consistent, Engaging Content",
    info: "We plan, create, schedule, and analyze your social media to help you connect with the right audience and build brand loyalty.",
    description:
      "From content strategy to real-time engagement, we manage your social channels with creativity and insight. Our team helps increase followers, boost engagement, and drive conversions.",
    whyUs: [
      "Platform-Specific Strategies (Instagram, LinkedIn, etc.)",
      "Content Calendar Planning",
      "Graphic & Video Post Design",
      "Ad Campaign Management",
      "Hashtag Research & SEO",
      "Analytics & Reporting",
      "Community Engagement & DMs",
    ],
    serviceProcess: [
      {
        title: "Strategy Planning",
        icon: sImg1,
        desc: "Set monthly goals, voice, and visual tone.",
      },
      {
        title: "Content Creation",
        icon: sImg2,
        desc: "Design visuals and write captions based on calendar.",
      },
      {
        title: "Publishing & Monitoring",
        icon: sImg3,
        desc: "Schedule posts and monitor engagement in real time.",
      },
      {
        title: "Analysis & Improvement",
        icon: sImg4,
        desc: "Track KPIs and refine strategy monthly.",
      },
    ],
    serviceOutcome: [
      "Steady follower growth",
      "Increased audience engagement",
      "Brand consistency across platforms",
      "Better ROI on ad campaigns",
      "Professional online presence",
    ],
    needDemo: `📱 Need help with socials?
Email: hello@anantkamalstudios.com
Phone: +91 76202 37235`,
  },
  //   End Core Section
  {
    Id: "15",
    sIcon: sdicon1,
    title: "Data source identification",
    slug: "Data-source",
    description:
      "We identify the new and existing data sources that can help drive your business forward.",
  },
  {
    Id: "16",
    sIcon: sdicon2,
    title: "Data ecosystem set up",
    slug: "Data-ecosystem",
    description:
      "We ingest your data into a data warehouse and set up your analytics to start making sense of it.",
  },
  {
    Id: "17",
    sIcon: sdicon3,
    title: "AI solution Design",
    slug: "AI-solution",
    description:
      "We design AI solutions that use your newly found insights to identify new opportunities for improvement.",
  },
  {
    Id: "18",
    sIcon: sdicon4,
    title: "Business-wide adoption",
    slug: "Business-wide",
    description:
      "We support you in helping your business understand, embrace, and adopt the change.",
  },
  {
    Id: "19",
    sIcon: scicon1,
    title: "Secure your network",
    slug: "Secure-your-network",
    features: [
      " Consistently Secure the Enterprise.",
      "Apply Al inline to prevent evasive.",
      "Simplify network security operations.",
      " Adopt Zero Trust across the network.",
      " Simplify with AI-Powered SASE.",
    ],
  },
  {
    Id: "20",
    sIcon: scicon2,
    title: "Secure your cloud",
    slug: "Secure-your-cloud",
    features: [
      "End-to-End Cloud Security.",
      "Real-Time Threat Detection.",
      "Identity & Access Management.",
      "Data Encryption & Privacy.",
      "Compliance & Governance.",
    ],
  },
  {
    id: "21",
    sIcon: scicon3,
    title: "Transform your SOC",
    slug: "Transform-your-SOC",
    features: [
      "Accelerate Threat Detection",
      "Automate Security Processes",
      "Streamline Incident Response",
      "Attack Surface Management",
      "Integrated Security Monitoring",
    ],
  },
  {
    id: "22",
    sIcon: scicon4,
    title: "Threat Intel & Response",
    slug: "Threat-Intel-&-Response",
    features: [
      "Let our experts be of your team.",
      "Move from reactive to proactive.",
      "Get world-class threat intelligence",
      "Every second counts when attack",
      "Make our experience your experience",
    ],
  },
  {
    id: "23",
    sIcon: scicon5,
    title: "Solutions by industry",
    slug: "Solutions-by-industry",
    features: [
      "Public sector",
      "Financial services",
      "Manufacturing",
      "Small & medium business solutions",
      "Healthcare",
    ],
  },

  {
    Id: "24",
    sIcon: cdicon1,
    title: "INFRASTRUCT URE DESIGN",
    slug: "INFRASTRUCT-URE-DESIGN",
  },
  {
    Id: "25",
    sIcon: cdicon2,
    title: "COSTS OPTIMIZATION",
    slug: "COSTS-OPTIMIZATION",
    bgClass: "cd-dot_bg2",
  },
  {
    Id: "26",
    sIcon: cdicon3,
    title: "INFRASTRUCTURE AS A CODE",
    slug: "INFRASTRUCTURE-AS-A-CODE",
    bgClass: "cd-dot_bg3",
  },
  {
    Id: "27",
    sIcon: cdicon4,
    title: "Continuous Integration",
    slug: "Continuous-Integration",
    bgClass: "cd-dot_bg4",
  },
  {
    Id: "28",
    sIcon: cdicon5,
    title: "Continuous Deployment",
    slug: "Continuous-Deployment",
  },
  {
    Id: "29",
    sIcon: cdicon6,
    title: "Blue Green Deployment",
    slug: "Blue-Green-Deployment",
    bgClass: "cd-dot_bg2",
  },
  {
    Id: "30",
    sIcon: "",
    title: "Data Consistency",
    slug: "Data-Consistency",
    bgClass: "cd-dot_bg3",
  },
  {
    Id: "31",
    sIcon: cdicon7,
    title: "Data Integrity",
    slug: "Data-Integrity",
    bgClass: "cd-dot_bg4",
  },
  {
    Id: "32",
    sIcon: cdicon8,
    title: "Redundancy",
    slug: "Redundancy",
  },
];

export default Services;
